import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useScrollToHash = ({ targetSection }) => {
  const { hash, pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (hash !== `#${targetSection}`) return;

    setTimeout(() => {
      const el = document.getElementById(targetSection);
      el?.scrollIntoView({ behavior: "smooth" });

      // URL se hash hata do
      navigate(pathname, { replace: true });
    }, 0);
  }, [hash, targetSection, navigate, pathname]);
};

export default useScrollToHash;
